import { useState } from 'react';
import { CompanyRegistration, CompanyRegistrationErrors } from '../types';
import { validateCompanyForm } from '../utils/validationUtils';

interface UseCompanyFormReturn {
  formData: Partial<CompanyRegistration>;
  errors: CompanyRegistrationErrors;
  isSubmitting: boolean;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
  handleSubmit: (e: React.FormEvent, onSuccess: () => void) => Promise<void>;
  resetForm: () => void;
}

const useCompanyForm = (): UseCompanyFormReturn => {
  const [formData, setFormData] = useState<Partial<CompanyRegistration>>({
    pais: 'ARGENTINA',
    terminos: false
  });
  const [errors, setErrors] = useState<CompanyRegistrationErrors>({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    const checked = (e.target as HTMLInputElement).checked;
    
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));

    // Clear error when user starts typing
    if (errors[name as keyof CompanyRegistrationErrors]) {
      setErrors(prev => ({
        ...prev,
        [name]: undefined
      }));
    }
  };

  const handleSubmit = async (e: React.FormEvent, onSuccess: () => void) => {
    e.preventDefault();
    
    const validationErrors = validateCompanyForm(formData);
    setErrors(validationErrors);
    
    if (Object.keys(validationErrors).length > 0) {
      return;
    }

    setIsSubmitting(true);

    try {
      // Simular envío del formulario
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // Mostrar mensaje de éxito
      alert('¡Empresa registrada exitosamente! Te hemos enviado un email de confirmación. Nuestro equipo se pondrá en contacto contigo en las próximas 24-48 horas.');
      
      // Resetear formulario
      resetForm();
      onSuccess();
    } catch (error) {
      alert('Error al registrar la empresa. Por favor intenta nuevamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setFormData({ pais: 'ARGENTINA', terminos: false });
    setErrors({});
  };

  return {
    formData,
    errors,
    isSubmitting,
    handleInputChange,
    handleSubmit,
    resetForm
  };
};

export default useCompanyForm;
